import { useState } from "preact/hooks";

type Position = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};

type HiddenCreateTriggerProps = {
  onTrigger: () => void;
  requiredClicks?: number;
  size?: number;
  position?: Position;
  ariaLabel?: string;
  className?: string;
  style?: preact.JSX.CSSProperties;
};

export default function HiddenCreateTrigger({
  onTrigger,
  requiredClicks = 5,
  size = 100,
  position = { right: 16, bottom: 16 },
  ariaLabel = "hidden-create-trigger",
  className,
  style,
}: HiddenCreateTriggerProps) {
  const [count, setCount] = useState(0);

  return (
    <div
      role="button"
      aria-label={ariaLabel}
      onClick={() => {
        const next = count + 1;
        if (next >= requiredClicks) {
          setCount(0);
          onTrigger();
        } else {
          setCount(next);
        }
      }}
      className={className}
      style={{
        position: "fixed",
        width: size,
        height: size,
        opacity: 0,
        cursor: "pointer",
        zIndex: 1000,
        top: position.top,
        right: position.right,
        bottom: position.bottom,
        left: position.left,
        ...style,
      }}
    />
  );
}
